import { createMappingWarning, isValidEmail, isValidIBAN, isValidPhoneNumber, } from "../utils.js";
export function mapEmailToContactDetails(email) {
    const errors = [];
    const warnings = [];
    const contactDetails = {};
    if (isValidEmail(email.email)) {
        contactDetails.email = email.email;
    }
    else {
        warnings.push(createMappingWarning("email.email", `Invalid email format: ${email.email}`, email.email));
    }
    return { contactDetails, errors, warnings };
}
export function mapPhoneNumberToContactDetails(phone) {
    const errors = [];
    const warnings = [];
    const contactDetails = {};
    if (isValidPhoneNumber(phone.phoneNumber)) {
        contactDetails.tel = phone.phoneNumber;
    }
    else {
        warnings.push(createMappingWarning("phone-number.phoneNumber", `Invalid phone number format: ${phone.phoneNumber}`, phone.phoneNumber));
    }
    return { contactDetails, errors, warnings };
}
export function mapIbanToOtherDetails(iban) {
    const errors = [];
    const warnings = [];
    const otherDetails = {};
    const cleanIban = iban.IBAN.replace(/\s/g, "");
    if (isValidIBAN(cleanIban)) {
        otherDetails.iban = cleanIban;
    }
    else {
        warnings.push(createMappingWarning("iban.IBAN", `Invalid IBAN format: ${iban.IBAN}`, iban.IBAN));
    }
    return { otherDetails, errors, warnings };
}
